<section class="lg-container">
  <cc-box>
    <div
      class="lg-container"
      box
      header >{{'LEAD_GENERATION.CREATOR.LEAD_GENERATION_TYPE' | translate }}
    </div>
    <form
      [formGroup]="chooseForm"
      box
      content>
      <mat-radio-group
        class="content"
        formControlName="creatorType">
        <div class="description">
          <div>{{'LEAD_GENERATION.CREATOR.CHOOSE_LG_TYPE' | translate }}</div>
          <div>{{'LEAD_GENERATION.CREATOR.INSTRUCTIONS_NEXT_STEP' | translate }}</div>
        </div>
        <div class="radio-container">
          <img
            src="../../../assets/img/creator_pop_up.png"
            alt=""
            [ngClass]="{ 'medium-grey-img': !isActive('popup')}">
          <mat-radio-button
            value="popup">{{'LEAD_GENERATION.CREATOR.RADIO_POPUP' | translate }}
          </mat-radio-button>
        </div>
        <div class="radio-container">
          <img
            src="../../../assets/img/creator_box.png"
            alt=""
            [ngClass]="{ 'medium-grey-img': !isActive('bubble')}">
          <mat-radio-button
            value="bubble">{{'LEAD_GENERATION.CREATOR.RADIO_BUBBLE' | translate }}
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </form>
    <div
      box
      content
      class="actions">
      <button
        mat-raised-button
        [disabled]="chooseForm.invalid"
        [routerLink]="['/lead-generation', 'projects', projectId ,'creator', chooseForm.get('creatorType').value]"
        color="primary-full">
        {{'LEAD_GENERATION.CREATOR.NEXT' | translate }}
      </button>
    </div>
  </cc-box>
</section>
